class IpoSecurity {
    tags;
}
export default IpoSecurity;
